import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import { GDialog } from 'gitart-vue-dialog';
import vueDebounce from 'vue-debounce';
import App from './App.vue';
// import { vueDebounce } from 'vue-debounce';
import router from './router';
import { getLanguageFile } from './i18n';
import { createVuetify } from 'vuetify';
import { VRangeSlider } from 'vuetify/components';
import { Ripple } from 'vuetify/directives';
import InstantSearch from 'vue-instantsearch/vue3/es';
import 'bootstrap/dist/css/bootstrap.css';
import 'instantsearch.css/themes/algolia-min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Vuetify configuration with tree-shaking
const vuetify = createVuetify({
    components: { VRangeSlider },
    directives: { Ripple },
});

// Ensure the app mounts only once
let isAppMounted = false;

const langCode = document.documentElement.lang || 'en';

getLanguageFile(langCode).then((messages) => {
    const i18n = createI18n({
        legacy: false,
        locale: langCode,
        fallbackLocale: 'en',
        globalInjection: true,
        messages: messages as any,
    });

    const container = document.getElementById('app');
    if (!container) {
        console.error('Mount container #app not found');
        return;
    }

    // Debug: Log mount attempt
    console.log('Attempting to mount Vue app', Date.now());

    // Check if already mounted globally or on this container
    if (isAppMounted || (container as HTMLElement).__vue_app__) {
        console.warn('Vue app already mounted, skipping mount');
        return;
    }

    const app = createApp(App)
        .use(i18n)
        .use(createPinia())
        .use(router)
        .use(InstantSearch)
        .use(vuetify)
        .component('GDialog', GDialog)
        .directive('debounce', vueDebounce({ lock: true }));

    app.mount(container);
    isAppMounted = true;
    console.log('Mounted Vue app on #app');
})
